import { Icon } from "./Icon.tsx";
import { useHelp } from "../shared/help-context.tsx";

/**
 * Fixed bottom-right, clear of the Toaster (which sits at bottom:20px, z 200).
 * The launcher is deliberately *below* the toast in stacking order: a toast is
 * transient and must never be hidden behind a permanent affordance.
 */
export function HelpLauncher() {
  const { open, openWith } = useHelp();
  return (
    <button
      type="button"
      className="help-launcher"
      data-help-launcher
      onClick={() => openWith()}
      aria-haspopup="dialog"
      aria-expanded={open}
      aria-label="Open Satatam Help"
      title="Satatam Help  ?"
    >
      <Icon name="spark" />
      <span>Help</span>
    </button>
  );
}
